import { render } from "./VerificationApplication.vue?vue&type=template&id=56eaf8d6&scoped=true"
import script from "./VerificationApplication.vue?vue&type=script&lang=js"
export * from "./VerificationApplication.vue?vue&type=script&lang=js"

import "./VerificationApplication.vue?vue&type=style&index=0&id=56eaf8d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56eaf8d6"]])

export default __exports__